
define( 'system/js/model',[ 'jclass', 'jquery' ], function( Class, $ ) {
	'use strict';

	/*
	===============================================================================
	Class: Model
	===============================================================================
	*/

	var Model = Class._extend( {

		/**
		 * Method: init
		 * @parma {Object} aOptions
		 */

		init: function( aOptions ) {
			var options = aOptions || { };

			this._options = $.extend( true, {
				parent: null
			}, options );

			this._parent = this._options.parent;
			this._data = { };
		},

		/**
		 * Method: getParent
		 */

		getParent: function( ) {
			return this._parent;
		},

		/**
		 * Method: merge
		 * @param {Mixed} aObject
		 * @param {Mixed} bObject
		 */

		merge: function( aObject, bObject ) {
			var o, i;

			if ( $.isPlainObject( aObject ) === true && $.isPlainObject( bObject ) === true ) {
				o = $.extend( true, { }, aObject );

				for ( i in bObject ) {
					if ( bObject.hasOwnProperty( i ) === true ) {
						if ( o.hasOwnProperty( i ) === true ) {
							if ( $.isPlainObject( o[ i ] ) === true && $.isPlainObject( bObject[ i ] ) === true ) {
								o[ i ] = this.merge( o[ i ], bObject[ i ] );
							}
							else if ( $.isArray( o[ i ] ) === true && $.isArray( bObject[ i ] ) === true ) {
								o[ i ] = $.merge( o[ i ], bObject[ i ] );

								o[ i ] = o[ i ].filter( function( aElement, aPosition, aArray ) {
									return aArray.indexOf( aElement ) === aPosition;
								} );

								/*
								if ( bObject[ i ].length === 0 ) {
									o[ i ] = [ ];
								}
								else {
									o[ i ] = $.merge( o[ i ], bObject[ i ] );
								}
								*/
							}
							else {
								o[ i ] = bObject[ i ];
							}
						}
						else {
							o[ i ] = bObject[ i ];
						}
					}
				}
			}
			else if ( $.isArray( aObject ) === true && $.isArray( bObject ) === true ) {
				o = $.merge( aObject, bObject );

				o = o.filter( function( aElement, aPosition, aArray ) {
					return aArray.indexOf( aElement ) === aPosition;
				} );
			}
			else {
				o = bObject;
			}

			return o;
		},

		/**
		 * Method: get
		 * @param {String} aKey
		 */

		get: function( aKey ) {
			var key = aKey || false,
				val = this._data,
				keys, i, len;

			if ( key !== false ) {
				keys = key.split( '.' );

				for ( i = 0, len = keys.length; i < len; i++ ) {
					if ( val.hasOwnProperty( keys[ i ] ) === true ) {
						val = val[ keys[ i ] ];
					}
					else {
						val = false;
						break;
					}
				}
			}

			return val;
		},

		/**
		 * Method: getAll
		 */

		getAll: function( ) {
			return this._data;
		},

		/**
		 * Method: set
		 * @param {String} aKey
		 * @param {Mixed} aValue
		 */

		set: function( aKey, aValue ) {
			var keys = aKey.split( '.' ),
				arr = this._data,
				i, len;

			for ( i = 0, len = keys.length; i < len; i++ ) {
				if ( arr.hasOwnProperty( keys[ i ] ) === true ) {
					if ( i === len - 1 ) {
						arr[ keys[ i ] ] = this.merge( arr[ keys[ i ] ], aValue );
					}
					else {
						arr = arr[ keys[ i ] ];
					}
				}
				else if ( i === len - 1 ) {
					arr[ keys[ i ] ] = this.merge( arr[ keys[ i ] ], aValue );
				}
				else {
					arr[ keys[ i ] ] = [ ];

					arr = arr[ keys[ i ] ];
				}
			}
		},

		/**
		 * Method: remove
		 * @param {Object} aKey
		 */

		remove: function( aKey ) {
			var key = aKey || false,
				val = this._data,
				keys, i, len;

			if ( key !== false ) {
				keys = key.split( '.' );

				for ( i = 0, len = keys.length; i < len; i++ ) {
					if ( val.hasOwnProperty( keys[ i ] ) === true ) {
						if ( i === len - 1 ) {
							delete val[ keys[ i ] ];
						}
						else {
							val = val[ keys[ i ] ];
						}
					}
					else {
						val = false;
						break;
					}
				}
			}
		}
	} );

	return Model;
} );

